import { z } from 'zod'

export const editCompumaticPunchSchema = z.object({
  punchType: z.enum(['clockIn', 'clockOut', 'breakOut', 'breakIn']),
})

export type EditCompumaticPunchSchema = z.infer<
  typeof editCompumaticPunchSchema
>
